import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';

import '../../assets/css/CollectionMainInfoPageVer.css'

import { AND, OR, NOT } from '../../config';
import Footer from "../../components/Footer";
import CollectionMaininfoPageCell from "../../components/CollectionMaininfoPageCell";

import TFAILogoMain from '../../assets/images/TFAI-logo-main.svg'
import bgPic5 from '../../assets/images/bg5.jpg'

const Rf = () => {
    const searchWord = localStorage.getItem('keyWord')// 查詢關鍵字
    const itemData = JSON.parse(localStorage.getItem('itemData'));
    const printPageRef = useRef();
    
    const wordArray = searchWord.split(new RegExp(`(${AND}|${OR}|${NOT})`, 'i'))
    let skipNext = false
    const searchArray = wordArray.filter((element) => {
        if (element === '' || element === AND || element === OR || skipNext) {
          skipNext = false;
          return false;
        } else if (element === NOT) {
          skipNext = true;
          return false;
        }
        return true;
    });

    // 判斷關鍵字是否需要添加 highlight 樣式
    const renderWithHighlight = (text) => {
        if (searchArray.length > 0 && text !== null) {
          const sortedArray = searchArray.sort((a, b) => b.length - a.length);
          const regex = new RegExp(sortedArray.join('|'), 'gi');
          // Matches array needed to maintain the correct letter casing
          const matches = [...text.matchAll(regex)];
          return text.split(regex).map((part, index) => (
            `${part}${index<matches.length ? `<div key={index} style="background-color: rgb(255, 255, 94); color: black; display: math;">${matches[index]}</div>` : ''}`
          )).join('');
        }
        return text;
    };

    const conditionCheck = (value)=>{        
        if(value){
            let target = value.replace(/\s/g,"")
            if(target === '' || target === '無標註'){
                return false
            } else{
                return true
            }
        } else{
            return false
        }
    }

    const createSummary = (print) => {
        return itemData && (conditionCheck(itemData['摘要/大綱']))?
            <div className="CollectionMainInfoMajorArea">
                <div className="CollectionMainInfoAreaPageVer">
                    {conditionCheck(itemData['摘要/大綱'])? 
                        <div className="CollectionMainInfoAreaPageVer" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"摘要 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <CollectionMaininfoPageCell>
                                    {createParagraph(itemData['摘要/大綱'])}
                                </CollectionMaininfoPageCell>
                            </div>
                        </div>
                    :null}
                    <div className="CollectionMainInfoAreaPageVer" style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"版本 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.版本) }} />
                        </div>
                    </div>               
                </div>
            </div>
        :null
    }
    const createPublishInfo = (print) => {
        return itemData && conditionCheck(itemData.出版者)?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.出版者) ?
                    <div className="CollectionMainInfoAreaPageVer">       
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>                 
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"出版者 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.出版者) }} />
                            </div>
                        </div>
                    </div>
                :null}    
            </div>
        :null
    }
    const createContributor = (print) => {
        return (itemData && itemData.工作人員 && itemData.工作人員 !== '') || (itemData && itemData.演員 && itemData.演員 !== '')?
            <div className="CollectionMainInfoAreaPageVer">
                {itemData && itemData.演員 && itemData.演員 !== ''?
                    <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"演員 "}</div>
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.演員) }} />
                            </CollectionMaininfoPageCell>
                        </div>
                    </div>
                :null}
                {itemData && itemData.工作人員 && itemData.工作人員 !== ''?
                    <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"工作人員 "}</div>    
                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                            <CollectionMaininfoPageCell>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.工作人員) }} />
                            </CollectionMaininfoPageCell>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createDateInfo = (print) => {
        return itemData && conditionCheck(itemData.數位修復年度) ?
            <div className="CollectionMainInfoMajorArea">
                {itemData && conditionCheck(itemData.數位修復年度) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"數位修復年度 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.數位修復年度) }} />
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createSpecInfo = (print) => {
        return itemData && (conditionCheck(itemData.解析度)||conditionCheck(itemData.畫面尺寸)||conditionCheck(itemData.畫面比例)||conditionCheck(itemData.格率)||conditionCheck(itemData.影片長度)||conditionCheck(itemData.聲道))?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.解析度) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"解析度 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.解析度) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.畫面尺寸) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"畫面尺寸 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.畫面尺寸) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.畫面比例) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"畫面比例 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.畫面比例) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.格率) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"格率 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.格率) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.影片長度) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"影片長度 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.影片長度) }} />
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.聲道) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"聲道 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.聲道) }} />
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    const createLanguageInfo = (print) => {
        return itemData && (conditionCheck(itemData.發音)||conditionCheck(itemData.字幕))?
            <div className="CollectionMainInfoMajorArea">
                {conditionCheck(itemData.發音) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"發音 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData.發音!==null ? itemData.發音.replace(';','；') : itemData.發音}
                            </div>
                        </div>
                    </div>
                :null}
                {conditionCheck(itemData.字幕) ?
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                            <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:print?'12px':null}}>{"字幕 "}</div>
                            <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:print?'12px':null}}>
                                {itemData.字幕!==null ? itemData.字幕.replace(';','；') : itemData.字幕}
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        :null
    }
    
    const createMedia=()=>{
        return (
            <div>
            {itemData && itemData.圖檔URL ?             
                <div><img alt="rfurl" src={itemData.圖檔URL} style={{width:'100%',objectFit:'cover'}}></img></div>                
                : null
            }
            </div>
        )
    }

    const createRefLink=()=>{
        return (
            itemData && conditionCheck(itemData.數位修復說明)?
            <div className="CollectionMainInfoAreaPageVer">
                <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                    <div style={{margin: '5px', fontWeight: 'bolder'}}>
                        <a href={itemData.數位修復說明}>{"數位修復說明"}</a>
                    </div>
                </div>
            </div>     
            :null
        )
    }

    const createParagraph=(text)=>{
        let tArray = text.split("\n")
        let output = tArray.map(para=>{
            return (<><div dangerouslySetInnerHTML={{ __html: renderWithHighlight(para) }} /><br/></>)
        })
        return output
    }

    const getTime = () => {
        let d = new Date()
        return d.toLocaleString()
    }

    return (<>
        <div className="TFAI-box">
            <div id="content-bg">
                <aside></aside>
                <div className="ctn-pic"><img alt="headPic" src={bgPic5} /></div>
            </div>
            <div className="container-xl">
                <div className="ctn-header">
                    <div className="ctn-logo d-none d-lg-block">
                        <Link to="/"><img src={TFAILogoMain} alt="TFAI logo" className="img-fluid"/></Link>
                    </div>
                    <div className="ctn-heading">
                        <h1><span>數位修復影片藏品</span></h1>
                    </div>
                </div>
                <div className="ctn-area">
                    <div className="data-header row">  
                        <div className="col-12 col-md-7 col-lg-6">
                            <h2><div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} /></h2>
                        </div>
                        <div className="col-12 col-md-5 col-lg-4 d-flex align-items-end share-links"> 
                            <div className="media-share">        
                                <ReactToPrint
                                    trigger={()=>                         
                                        <svg className="bi bi-printer-fill" viewBox="0 0 16 16">
                                            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                                            <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                        </svg>
                                    }
                                    content={()=>printPageRef.current}
                                />  
                            </div>  
                        </div>
                    </div>
                    <div className="data-body row">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div >
                                {createSummary()}
                                {createPublishInfo()}
                                {createContributor()}
                                {createDateInfo()}
                                {createSpecInfo()}
                                {createLanguageInfo()}
                            </div>
                        </div>
                        <div className="data-img col-12 col-md-5 col-lg-4 ">
                            {createMedia()}
                            {createRefLink()}
                            <aside>
                                <span>典藏單位</span>
                                <p>國家電影及視聽文化中心</p>
                            </aside>
                            <aside>                            
                                <p style={{marginBottom:'2px',color:'black',fontWeight:'bolder'}}>
                                    藏品能否租借，本中心需視藏品狀態、有無權限等因素而評估，若需取用請填寫
                                    <a href="https://www.tfai.org.tw/downloads/rent">資料借出使用申請單</a>
                                    ，向本中心提出申請。
                                </p>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>  

            <div style={{ display: "none" }}>
                <div className="CollectionMainInfoMainBodyPrintPage" ref={printPageRef}>
                    <div>
                        <div style={{display:'flex'}}>
                            <div style={{position:'relative',width:'220px'}}>
                                <div style={{position:'absolute',bottom:'0px',fontSize:'12px'}}>
                                    {"國家電影及視聽文化中心 藏品檢索系統"}
                                </div>
                            </div>
                            <div>
                                <img alt="logo" src={TFAILogoMain}/>
                            </div>
                        </div>
                    </div>
                    <div style={{display:'flex'}}>
                        <div style={{width:'98%', margin:'1vw 1vw 0 1vw', fontSize:'20px'}}>
                            <div className="CollectionMainTitle" style={{borderBottom:'1px solid gray'}}>
                                <div className="CollectionMainInfoRow">
                                    <div className="MovieTitle" style={{fontSize:'20px'}}>                                        
                                        <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.標題) }} />
                                    </div>
                                </div>
                                {conditionCheck(itemData.英文標題) ?
                                    <div className="CollectionMainInfoRow">
                                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:'12px'}}>{"翻譯片名 "}</div>
                                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:'12px'}}>          
                                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(itemData.英文標題) }} />
                                        </div>
                                    </div>
                                :null}
                            </div>
                        </div>
                    </div>
                    <div className="CollectionMainInfoTableBody">                 
                        <div className='CollectionMainInfoTableColumnPrint'>
                            <div >
                                {createSummary(true)}
                                {createPublishInfo(true)}
                                {createContributor(true)}
                                {createDateInfo(true)}
                                {createSpecInfo(true)}
                                {createLanguageInfo(true)}
                                {createMedia()}
                            </div>           
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="MovieRowTitle" style={{fontSize:'14px'}}>{"管理權"}</div>
                            </div>
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="CollectionMainInfoRowTitlePageVer" style={{width:'100%',fontSize:'12px'}}>{"國家電影及視聽文化中心"}</div>
                            </div>
                        </div>
                    </div>
                    <div style={{float:'right',paddingBottom:'50px'}} >
                        <div>
                            <div style={{display:'flex',fontSize:'12px'}}>
                                <div>列印時間 ：</div>
                                <div>{getTime()}</div>
                            </div>
                        </div>                
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    </>)
};

export default Rf;